export const HANDLE_PROJECTS = 'HANDLE_PROJECTS';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const HANDLE_SOURCE_DATA = 'HANDLE_SOURCE_DATA';
export const HANDLE_CARD_INFO = 'HANDLE_CARD_INFO';
export const RESET_STORE = 'RESET_STORE';
export const HANDLE_EDIT_MODE = 'HANDLE_EDIT_MODE';
export const HANDLE_REPORT_KEY = 'HANDLE_REPORT_KEY';
export const HANDLE_TEMPLATE_ID = 'HANDLE_TEMPLATE_ID';
export const HANDLE_TRIGGER_INFO = 'HANDLE_TRIGGER_INFO';
export const HANDLE_SLACK_DATA = 'HANDLE_SLACK_DATA';
export const HANDLE_REPORT_ACCESS_DATA = 'HANDLE_REPORT_ACCESS_DATA';
export const HANDLE_CARD_TEMPLATE_ID = 'HANDLE_CARD_TEMPLATE_ID';
export const HANDLE_ISSUE_CARD_INFO = 'HANDLE_ISSUE_CARD_INFO';
export const HANDLE_APPEARANCE_INFO = 'HANDLE_APPEARANCE_INFO';
export const HANDLE_LOADING_INFO = 'HANDLE_LOADING_INFO';
export const HANDLE_ERROR_INFO = 'HANDLE_ERROR_INFO';
export const HANDLE_SORTLIST_DATA = 'HANDLE_SORTLIST_DATA';
export const SET_INITIAL_SORTLIST_DATA = 'SET_INITIAL_SORTLIST_DATA';
export const HANDLE_ISSUE_API_DATA = 'HANDLE_ISSUE_API_DATA';
export const HANDLE_REPORT_OPTIONS = 'HANDLE_REPORT_OPTIONS';
export const HANDLE_SEND_NOTIFICATION = 'HANDLE_SEND_NOTIFICATION';
